import { Card, CardContent } from "@/components/ui/card";

export const AdvertisementSkeleton = () => {
  return (
    <Card className="mb-6 overflow-hidden border-b bg-gradient-to-r from-primary/15 to-primary/20">
      <CardContent className="space-y-9 px-6 pb-6">
        <div className="mt-5 space-y-4">
          <div className="h-6 w-1/2 animate-pulse rounded-md bg-primary/10" />
        </div>
        <div className="space-y-4">
          <div className="h-6 w-1/2 animate-pulse rounded-md bg-primary/10" />
        </div>
      </CardContent>
    </Card>
  );
};
